
import { useLanguage } from "../../Translations/LenguageContext";
import { MdOutlineCheckCircle, MdOutlineCircle } from "react-icons/md";
import Spinner from "../../Components/Spinner";
import ErrorMessage from "../../Components/ErrorMessage";
import { Dropdown } from "react-bootstrap";
import { PiMagnifyingGlass } from "react-icons/pi";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const GeoLanguage = ({
    account_id,
    org_id,
    geo_id,
    selectedLanguage,
    setSelectedLanguage,
    saveLanguageGeo,
    setLoadingSave,
    loadingSave,
    setErrorMessage,
    errorMessage
}) => {
    const { t } = useLanguage();
    const navigate = useNavigate()
    const [searchTerm, setSearchTerm] = useState("");

    const languages = [
        "afrikaans",
        "albanian",
        "amharic",
        "arabic",
        "armenian",
        "azerbaijani",
        "basque",
        "belarusian",
        "bengali",
        "bosnian",
        "breton",
        "bulgarian",
        "burmese",
        "catalan",
        "chinese",
        "croatian",
        "czech",
        "danish",
        "dutch",
        "english",
        "estonian",
        "finnish",
        "french",
        "galician",
        "georgian",
        "german",
        "greek",
        "gujarati",
        "hebrew",
        "hindi",
        "hungarian",
        "icelandic",
        "indonesian",
        "irish",
        "italian",
        "japanese",
        "javanese",
        "kannada",
        "kazakh",
        "khmer",
        "korean",
        "kurdish",
        "kyrgyz",
        "lao",
        "latin",
        "latvian",
        "lithuanian",
        "luxembourgish",
        "macedonian",
        "malay",
        "malayalam",
        "maltese",
        "marathi",
        "mongolian",
        "nepali",
        "norwegian",
        "odia",
        "pashto",
        "persian",
        "polish",
        "portuguese",
        "punjabi",
        "romanian",
        "russian",
        "sami",
        "sindhi",
        "sinhala",
        "slovak",
        "slovenian",
        "somali",
        "spanish",
        "sundanese",
        "swahili",
        "swedish",
        "filipino",
        "tajik",
        "tamil",
        "telugu",
        "thai",
        "tibetan",
        "tigrinya",
        "turkish",
        "turkmen",
        "ukrainian",
        "urdu",
        "uyghur",
        "uzbek",
        "vietnamese",
        "welsh",
        "xhosa",
        "yoruba",
        "zulu"
    ];

    const filteredLanguages = languages.filter((language) =>
        language.toLowerCase().includes(searchTerm.trim().toLowerCase())
    );

    const navigateBack = () => {
        setLoadingSave(false)
        setErrorMessage({ message: "", display: false });
        navigate(`/console/organizations/${org_id}/geo/${geo_id}/property`);
    };

    return (
        <div className="geo_context_cont">
            <p className="add_new_source_cont_title fade-in">
                {t.geo.select_a_language}
            </p>

            <p className="add_new_source_cont_desc fade-in">
                {t.geo.select_a_language_desc}
            </p>

            <div className="language_cont">
                <Dropdown>
                    <Dropdown.Toggle
                        as="div"
                        className="register_form_first fade-in"
                    >
                        {selectedLanguage
                            ? selectedLanguage.charAt(0).toUpperCase() +
                            selectedLanguage.slice(1)
                            : t.geo.select_language
                        }
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="custom_dropdown_menu">
                        <div className="dropdown_container fade-in">
                            <div className="scrollable_dropdown_cont">
                                {filteredLanguages.length > 0 ? (
                                    filteredLanguages.map((language) => (
                                        <button
                                            key={language}
                                            type="button"
                                            className="settings_link"
                                            style={{ textTransform: "capitalize" }}
                                            onClick={() => setSelectedLanguage(language)}
                                        >
                                            <i>
                                                {selectedLanguage === language
                                                    ? <MdOutlineCheckCircle />
                                                    : <MdOutlineCircle />
                                                }
                                            </i>
                                            {language}
                                        </button>
                                    ))
                                ) : (
                                    <div className="no_data_dropdown fade-in">
                                        <p>{t.no_data_found_by_search}</p>
                                    </div>
                                )}
                            </div>
                            <div className="filter_dropdown fade-in">
                                <input
                                    className="filter_input"
                                    placeholder={t.search_filter}
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                                <span className="filter_input_icon"><PiMagnifyingGlass /></span>
                            </div>
                        </div>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
            <p className="warning_source_message fade-in">
                {t.geo.select_language_warning}
            </p>

            <div className="modal_footer_err_cont">
                <ErrorMessage err={errorMessage} />
            </div>

            <div className="open_frame_body_footer">
                <button
                    type="button"
                    className="modale_save_btn fade-in"
                    onClick={navigateBack}
                >
                    <i className="fa-solid fa-chevron-left"></i>
                    {t.back}
                </button>
                {selectedLanguage && (
                    <button
                        type="button"
                        className="modale_save_btn fade-in"
                        onClick={saveLanguageGeo}
                    >
                        {loadingSave ? (
                            <Spinner loading={loadingSave} />
                        ) : (
                            <>
                                {t.next}
                                <i className="fa-solid fa-chevron-right"></i>
                            </>
                        )}
                    </button>
                )}
            </div>
        </div>
    );
};

export default GeoLanguage;
